import { asideMenuCssClasses, validBreakpoints, checkBreakpoint } from '@coreui/vue/src/shared/classes'
import toggleClasses from '@coreui/vue/src/shared/toggle-classes'

export default {
  methods: {
    toggleAside(force) {
      this.mobile = true;
      const [display, mobile] = [this.display, this.mobile]
      let cssClass = asideMenuCssClasses[0]
      if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
        cssClass = `aside-menu-${display}-show`
      }
      toggleClasses(cssClass, asideMenuCssClasses, force);
      this.toggled();
    },

    toggled() {

    }
  },
};
